import { theme } from "nectar-ui";
import { DASHBOARD_CHART_TYPES } from "@utils/constants/dashboard/dashboardModuleConstants";
import { ApexOptions } from "apexcharts";

export type SERIES_TYPE = {
  name: string;
  data: number[];
};

export type RADAR_CHART_INITIAL_STATE_TYPE = {
  users: string[];
  series: {
    withUpdates: SERIES_TYPE[];
    withoutUpdates: SERIES_TYPE[];
  };
  noData: {
    notEnoughUsers: boolean;
    withUpdates: boolean;
    withoutUpdates: boolean;
  };
};

export const RADAR_CHART_INITIAL_STATE: RADAR_CHART_INITIAL_STATE_TYPE = {
  users: [],
  series: { withUpdates: [], withoutUpdates: [] },
  noData: {
    notEnoughUsers: false,
    withUpdates: true,
    withoutUpdates: true,
  },
};

export const MINIMUM_RESPONSIBLE_NUMBER = 3;

export const getChartOptions = (
  users: string[]
): { withUpdates: ApexOptions; withoutUpdates: ApexOptions } => {
  const generalOptions: ApexOptions = {
    chart: {
      id: DASHBOARD_CHART_TYPES.LAWSUIT_UPDATES_RADAR.chart,
      height: 350,
      type: "radar",
      fontFamily: theme.nectar.fontStack.default,
      offsetY: 36,
      toolbar: {
        show: false,
      },
    },
    xaxis: {
      categories: users,
      labels: {
        style: {
          fontWeight: 300,
        },
      },
    },
    yaxis: {
      show: false,
    },
  };

  return {
    withUpdates: {
      ...generalOptions,
      colors: [theme.nectar.colors.blue500],
    },
    withoutUpdates: {
      ...generalOptions,
      colors: [theme.nectar.colors.primary800],
    },
  };
};
